import React, { useState, useEffect } from 'react';
import CategoryLink from 'common/components/UI/sideBarLinks/SideBarLinks';
import Poll from 'modules/help/components/Poll';
import Typography from 'common/components/tags/typography/Typography';
import Box from 'common/components/UI/box/Box';
import { useHelpContext } from 'common/context/help-context';
import Skeleton from 'common/components/npm/skeleton/Skeleton';
import SkeletonText from 'common/components/npm/skeleton/Text';

const PostDetail = ({ data }: { data: FAQ }) => {
  const [links, setLinks] = useState<{ title: string; href: string }[]>([]);
  const [date, setDate] = useState<any>(null);
  const HelpCtx = useHelpContext();


  useEffect(() => {
    if (HelpCtx?.categories)
      setLinks(
        HelpCtx?.categories?.map((item) => {
          return { title: item.title, href: `/help/categories/` + item.id };
        })
      );
  }, [HelpCtx?.categories]);

  useEffect(() => {
    if (data) setDate(new Date(data?.createdAt).toDateString());
  }, [data]);

  return (
    <section className='md:container md:max-w-[100%]'>
      <div className='grid grid-cols-7 md:py-5 xl:grid-cols-10'>
        <div className='container col-span-7 md:col-span-2 md:m-0 md:max-w-full md:p-0 '>
          <CategoryLink title='FAQs' links={links} />
        </div>
        <Box
          className={`col-span-7 rounded-none md:col-span-5 md:rounded-4 xl:col-span-8`}
        >
          {data ? (
            <Typography tag='h3' className='pb-8 normal-case md:pb-7 xl:pb-9'>
              {data?.title}
            </Typography>
          ) : (
            <Skeleton className='mb-8 h-7 w-2/3 rounded-2 md:mb-7 xl:mb-9 xl:h-10' />
          )}
          {data?.article ? (
            <div dangerouslySetInnerHTML={{ __html: data?.article }} />
          ) : (
            <SkeletonText />
          )}
          <p className='py-8 text-[1.4rem] font-normal text-gray3 md:py-9 md:text-[1.2rem] xl:py-12'>
            {date}
          </p>
          {/* <Poll
            title="Was this Post useful?"
            agree={true}
            disAgree={false}
            agreeMethod={() => console.log("hi")}
            disAgreeMethod={() => console.log("fkj")}
          /> */}
        </Box>
      </div>
    </section>
  );
};

export default PostDetail;
